export interface QuoteCard {
  text: string;
  name: string;
  role: string;
  image: string;
}

export const QUOTE_CARDS: QuoteCard[] = [
  {
    text: 'OrderYaa transformed how we manage production and inventory at Alfa Bakers. We reduced stock wastage by over 30% in just three months and our order fulfilment has never been smoother. It\'s now the backbone of our daily operations.',
    name: 'Ali Raza',
    role: 'CEO, Alfa Bakers',
    image: 'images/common/client3.png',
  },
  {
    text: 'Managing kitchen operations across multiple outlets used to be a nightmare. With OrderYaa, our procurement, staff schedules, and daily reporting all run from one place. The team adopted it quickly and the results were immediate.',
    name: 'Bilal Ahmed',
    role: 'Operations Head, Bake House',
    image: 'images/common/client5.png',
  },
  {
    text: 'As a retail director, real-time visibility across branches is everything. OrderYaa gives us live sales data, automated reorder alerts, and clear financial summaries, exactly what Prime Retail needed to scale confidently and stay ahead.',
    name: 'Umer Farooq',
    role: 'Director, Prime Retail',
    image: 'images/common/client7.png',
  },
];
